/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useState } from 'react';
import { Button, DatePicker, Form, Input, Message, Table, TableColumnProps } from '@arco-design/web-react';
import dayjs from 'dayjs';
import { get } from '../requestNew';
import PhoneCell from '../components/PhoneCell';

import './index.scss';
import { UmsUserAction } from './types';

const FormItem = Form.Item;

function UserAction() {
  const [form] = Form.useForm();
  const [pageSize, setPageSize] = useState(20);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataList, setDataList] = useState<UmsUserAction[]>([]);
  const [loading, setLoading] = useState(false);

  const columns: TableColumnProps[] = [
    {
      title: '序号',
      width: 60,
      render: (_, record, i) => (pageNum - 1) * pageSize + i + 1
    },
    {
      title: '手机号',
      dataIndex: 'phone',
      width: 160,
      render: text => <PhoneCell phone={text} />
    },
    {
      title: 'openid',
      dataIndex: 'openid',
      width: 200,
      render: text => text || '-'
    },
    {
      title: '页面路由',
      dataIndex: 'pageRoute',
      width: 200,
      render: text => text || '-'
    },
    {
      title: '事件类型',
      dataIndex: 'eventType',
      width: 120,
      render: text => text || '-'
    },
    {
      title: '上报时间',
      dataIndex: 'reportTime',
      width: 180,
      render: text => text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    {
      title: '扩展字段',
      dataIndex: 'extensionField',
      width: 200,
      render: text => text || '-'
    }
  ];

  const getList = (reset?: boolean) => {
    setLoading(true);
    if (reset) {
      setPageNum(1);
    }
    const obj: any = form.getFieldsValue();
    const params: any = {
      ...obj,
      pageSize,
      pageNum: reset ? 1 : pageNum
    };

    // 从日期范围中提取开始时间和结束时间
    if (obj.dateRange && Array.isArray(obj.dateRange) && obj.dateRange.length === 2) {
      params.reportTimeStart = dayjs(obj.dateRange[0]).format('YYYY-MM-DD HH:mm:ss');
      params.reportTimeEnd = dayjs(obj.dateRange[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss');
    }
    // 删除 dateRange 字段，避免提交到后端
    delete params.dateRange;

    get('/backend/umsUserAction/list', params)
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const { list, total } = data;
          setTotal(total || 0);
          setDataList(list || []);
        } else {
          Message.error(message || '请求失败');
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleReset = () => {
    form.resetFields();
    setPageNum(1);
    setPageSize(20);
    const params: any = {
      pageSize: 20,
      pageNum: 1
    };
    setLoading(true);
    get('/backend/umsUserAction/list', params)
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const { list, total } = data;
          setTotal(total || 0);
          setDataList(list || []);
        } else {
          Message.error(message || '请求失败');
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getList(false);
  }, [pageNum, pageSize]);

  return (
    <div className="user-action table-flex">
      <Form style={{ width: '100%' }} autoComplete="off" layout="inline" form={form}>
        <FormItem label="手机号" field="phone">
          <Input style={{ width: 150 }} placeholder="请输入" allowClear />
        </FormItem>
        <FormItem label="openid" field="openid">
          <Input style={{ width: 200 }} placeholder="请输入" allowClear />
        </FormItem>
        <FormItem label="页面路由" field="pageRoute">
          <Input style={{ width: 150 }} placeholder="请输入" allowClear />
        </FormItem>
        <FormItem label="时间范围" field="dateRange">
          <DatePicker.RangePicker
            style={{ width: 300 }}
            showTime
            disabledDate={(current) => current && current > dayjs().endOf('day')}
          />
        </FormItem>
        <FormItem>
          <Button type="primary" onClick={() => getList(true)} loading={loading}>
            查询
          </Button>
        </FormItem>
        <FormItem>
          <Button type="outline" onClick={handleReset} loading={loading}>
            重置
          </Button>
        </FormItem>
      </Form>
      <div className="table-content">
        <Table
          rowKey="id"
          columns={columns}
          data={dataList}
          className="table-scroll"
          loading={loading}
          pagination={{
            sizeCanChange: true,
            pageSize,
            total,
            showTotal: true,
            current: pageNum,
            onChange: (num, size) => {
              setPageNum(num);
              if (size && size !== pageSize) {
                setPageSize(size);
              }
            }
          }}
          scroll={{ y: '100%', x: '100%' }}
        />
      </div>
    </div>
  );
}

export default UserAction;

